import { render, staticRenderFns } from "./PolicyCoverage.vue?vue&type=template&id=1f9bc04e&"
import script from "./PolicyCoverage.vue?vue&type=script&lang=js&"
export * from "./PolicyCoverage.vue?vue&type=script&lang=js&"
import style0 from "./PolicyCoverage.vue?vue&type=style&index=0&id=1f9bc04e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports